import React from "react";
import { Typography, Box, Button } from "@material-ui/core";
import { useStyles } from "./style";
import { useStateValue } from "../../providers/StateProvider";
import { useHistory } from "react-router-dom";

export default function Home(): JSX.Element {
  const classes = useStyles();
  const history = useHistory();
  const [{ user, currentTicketOffice }] = useStateValue();
  return (
    <>
      <Box className={classes.main}>
        <Typography className={classes.textTitleHome}>
          {user && `Bem-vindo(a), ${user?.nome}.`}
        </Typography>
        <img
          src="/assets/images/logo_home.svg"
          alt="Home"
          className={classes.imgHome}
        />
        <Box className={classes.boxButtons}>
          {currentTicketOffice?.tipo === "Interno" && (
            <div className={classes.boxButtonsConsulta}>
            <Button
              variant="contained"
              className={classes.buttonLink}
              onClick={() => history.push("/agendamento_interno")}
            >
              Atendimento internos
            </Button>
            </div>
          )}

          {currentTicketOffice?.tipo === "Consulta" && (
            <div className={classes.boxButtonsConsulta}>
              <Button
                variant="contained"
                className={classes.buttonLink}
                onClick={() => history.push("/consulta_agendamento")}
              >
                LISTA DE AGENDAMENTOS
              </Button>
            </div>
          )}
          {currentTicketOffice?.tipo === "Presencial" && (
            <div className={classes.boxButtonsConsulta}>
            <Button
              variant="contained"
              className={classes.buttonLink}
              onClick={() => history.push("/agendamento")}
            >
              atendimento
            </Button>
            </div>
          )}
          {currentTicketOffice?.tipo === "Online" && (
            <Button
              variant="contained"
              className={classes.buttonLink}
              onClick={() => history.push("/atendimento")}
            >
              Atendimento Online
            </Button>
          )}

          {currentTicketOffice?.tipo === "Diario" && (<>
            <Button
              variant="contained"
              className={classes.buttonLink}
              onClick={() => history.push("/atendimento_diario")}
            >
              Agendamento Espontâneo
            </Button>
          </>
          )}
        </Box>
      </Box>
    </>
  );
}
